import { toast } from "./utils";

let modalEl: HTMLDivElement | null = null;
let urlInputEl: HTMLInputElement | null = null;

function ensureModal(): HTMLDivElement {
  if (modalEl) return modalEl;

  modalEl = document.createElement("div");
  modalEl.className = "share-modal-overlay hidden";
  modalEl.innerHTML = `
    <div class="share-modal">
      <div class="share-modal-header">
        <span>Share This Document</span>
        <button class="share-modal-close" aria-label="Close">&times;</button>
      </div>
      <div class="share-modal-body">
        <div class="share-modal-url-row">
          <input class="share-modal-url" type="text" readonly />
          <button class="share-modal-copy" data-tooltip="Copy link">Copy</button>
        </div>
        <p class="share-modal-hint">Anyone with this link can view your document. Links expire after 90 days.</p>
      </div>
      <div class="share-modal-loading hidden">
        <span class="share-modal-spinner"></span> Creating share link&hellip;
      </div>
      <div class="share-modal-error hidden"></div>
    </div>
  `;

  document.body.appendChild(modalEl);

  urlInputEl = modalEl.querySelector(".share-modal-url");

  modalEl
    .querySelector(".share-modal-close")!
    .addEventListener("click", hideModal);

  modalEl.addEventListener("click", (e) => {
    if (e.target === modalEl) hideModal();
  });

  modalEl.querySelector(".share-modal-copy")!.addEventListener("click", () => {
    if (!urlInputEl?.value) return;
    navigator.clipboard.writeText(urlInputEl.value).then(() => {
      toast("Share link copied to clipboard!");
    });
  });

  document.addEventListener("keydown", (e) => {
    if (
      e.key === "Escape" &&
      modalEl &&
      !modalEl.classList.contains("hidden")
    ) {
      hideModal();
    }
  });

  return modalEl;
}

export function showModal(): void {
  const modal = ensureModal();
  modal.classList.remove("hidden");
  setLoading(true);
  setError(null);
}

export function hideModal(): void {
  modalEl?.classList.add("hidden");
}

export function setLoading(loading: boolean): void {
  const modal = ensureModal();
  const body = modal.querySelector(".share-modal-body") as HTMLElement;
  const spinner = modal.querySelector(".share-modal-loading") as HTMLElement;
  body.classList.toggle("hidden", loading);
  spinner.classList.toggle("hidden", !loading);
}

export function setUrl(url: string): void {
  ensureModal();
  if (urlInputEl) {
    urlInputEl.value = url;
  }
  setLoading(false);
  setError(null);
}

export function setError(message: string | null): void {
  const modal = ensureModal();
  const errorEl = modal.querySelector(".share-modal-error") as HTMLElement;
  if (message) {
    errorEl.textContent = message;
    errorEl.classList.remove("hidden");
    setLoading(false);
  } else {
    errorEl.textContent = "";
    errorEl.classList.add("hidden");
  }
}
